import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { OperadorOperacaoPage } from '../operador-operacao/operador-operacao';
import { OperadorInfopedidoPage } from '../operador-infopedido/operador-infopedido';

import { Tools, Services, User, Api } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-operador-caixas',
  templateUrl: 'operador-caixas.html',
})
export class OperadorCaixasPage {
  code:string='';
  pedidos:any=[];
  separacao:any={_id:false};
  pedido:any={
    pedido:{
      codigo:'',
      initEntrega:'00-00-00T00:00:00',
      fimEntrega:'00-00-00T00:00:00'
    },
    cliente:{
      nome:''
    },
    entrega:{
      caixas:[],
      caixa:''
    },
    items:[]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tools: Tools,
    private services: Services,
    private user: User,
    private api: Api,
    private barcodeScanner: BarcodeScanner
  ) {
  }

  ionViewDidLoad() {
    var pedidos = this.navParams.get('item');
    var separacao = this.navParams.get('separacao');

    if(pedidos){this.pedidos = pedidos}
    if(separacao){this.separacao = separacao}

    console.log(this.pedidos);
    console.log(this.separacao);

    if(!this.separacao._id){
      console.log('init1');
      this.init1();
    }else{
      console.log('init2');
      this.init2();
    }
  }

  init1(){
    for(let pedido of this.pedidos){
      if(!pedido.entrega.caixa){
        pedido.entrega.caixa='';
      }
    }
  }

  init2(){
    let loading = this.tools.showLoading('Carregando...');
    loading.present();

    this.services.getData('cadPedidos',{'id':{$in:this.separacao.pedidosId}},(result)=>{
      this.pedidos = result.data;
      this.init1();
      loading.dismiss();
    });

  }

  iniciar(){
    if(this.separacao._id){
      this.changeboxes();
      return
    }

    var caixas = {}
    for(let pedido of this.pedidos){
      if(pedido.entrega.caixas.length==0){
        this.tools.showAlert('toast','É necessário ao menos uma caixa por pedido!');
        return
      }

      if(!caixas[pedido._id+'']){
        caixas[pedido._id+''] = pedido.entrega.caixas
      }
    }

    var loading = this.tools.showLoading('Carregando...');
    loading.present();

    var url = 'http://barbosa.ibrs.com.br:5000/api/tracking/iniciarsep';

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "operadorId":this.user.getUser()._id+'',
      "pedidosId":this.pedidos.map(e=>e._id+''),
      "caixas":caixas
    }

    let self = this;
    this.api.sendPost(url,postObj,{},function(result){
      console.log(result);

      if(result.status){
        self.tools.storage('save','separacao',JSON.stringify(result.data),(e) => {
          if(e.status){
            console.log(e);
            self.navCtrl.push(OperadorOperacaoPage,{item:result.data});
            self.tools.showAlert('toast','Separação Criada');
          }
        });
      }else{
        self.tools.showAlert('toast',result.msg);
      }

      loading.dismiss();
    });
  }

  changeboxes(){
    var loading = this.tools.showLoading('Carregando...');
    loading.present();

    var caixas = {}
    for(let pedido of this.pedidos){
      if(pedido.entrega.caixas.length==0){
        this.tools.showAlert('toast','É necessário ao menos uma caixa por pedido!');
        return
      }
      var check = this.separacao.caixas.find(e=>e.codigo == pedido.pedido.codigo);
      if(check){
        check.caixas = pedido.entrega.caixas;
      }else{
        this.separacao.caixas.push({codigo:pedido.pedido.codigo,caixas:pedido.entrega.caixas,caixa:pedido.entrega.caixas[pedido.entrega.caixas.length-1]})
      }
    }

    let self = this;
    this.services.save('cadSeparacoes',this.separacao,function(result){
      console.log(result);
      if(result.status){
        self.navCtrl.push(OperadorOperacaoPage,{item:self.separacao});
      }else{
        self.tools.showAlert('toast','Erro ao salvar caixas.');
      }

      loading.dismiss();
    });
  }

  openScanner(idx:any){
    this.barcodeScanner.scan().then(barcodeData => {
      if(barcodeData.text==''){return}
      barcodeData.text = barcodeData.text.toUpperCase();
      if(this.pedidos[idx].entrega.caixas.indexOf(barcodeData.text)>=0){this.tools.showAlert('toast','Caixa existente.');return}
      this.pedidos[idx].entrega.caixas.push(barcodeData.text);
      console.log(this.pedidos[idx]);
    }).catch(err => {
        console.log('Error', err);
    });
  }

  addCaixa(idx:any){
    var code = this.pedidos[idx].entrega.caixa.toUpperCase();

    if(code == ''){this.tools.showAlert('toast','Preencha o campo para adicionar manualmente.');return;}
    if(this.pedidos[idx].entrega.caixas.indexOf(code)>=0){this.tools.showAlert('toast','Caixa existente.');return}

    this.pedidos[idx].entrega.caixas.push(code);
    this.pedidos[idx].entrega.caixa = '';
    console.log(this.pedidos[idx]);
  }

  removeCaixa(idx:any,i:any){
    this.pedidos[idx].entrega.caixas.splice((i*1),1);
  }

  openPedido(pedido){
    this.navCtrl.push(OperadorInfopedidoPage,{item:pedido});
  }
}



// WEBPACK FOOTER //
// ./src/pages/operador-caixas/operador-caixas.ts